import { render, staticRenderFns } from "./GoodsAllocation.vue?vue&type=template&id=25bdb18e&scoped=true&"
import script from "./GoodsAllocation.vue?vue&type=script&lang=js&"
export * from "./GoodsAllocation.vue?vue&type=script&lang=js&"
import style0 from "./GoodsAllocation.vue?vue&type=style&index=0&id=25bdb18e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bdb18e",
  null
  
)

export default component.exports